import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import recordingReducer from "./reducers/recordingReducer";
import meetingReducer from "./reducers/meetingReducer";
import snackbarReducer from "./reducers/snackbarReducer";
import interventionReducer from "./reducers/interventionReducer";
import acronymReducer from "./reducers/acronymReducer";
import userDetailsPermissionReducer from "./reducers/userDetailsPermissionReducer";
import userManagementReducer from "./reducers/userManagementReducer";

export const store = configureStore({
  reducer: {
    recording: recordingReducer,
    meeting: meetingReducer,
    snackbar: snackbarReducer,
    intervention: interventionReducer,
    acronym: acronymReducer,
    userDetailsPermission: userDetailsPermissionReducer,
    userManagement: userManagementReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
